import { CheckCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { WaveDotsLoader } from "@src/components/wave-dots-loader";
import { formatBytes } from "@src/util/common/format-byte";
import { Tooltip } from "antd";
import React from "react";
import { DryRunInfo } from ".";

const renderSpecialMessage = (msg: string) => {
    if (msg.includes("Query must have at least 1 metric")) {
        return (
            <div className="flex flex-col ">
                <span>No metric selected</span>
                <span>Please choose a quantitative variable to explore </span>
            </div>
        );
    }
    if (msg.includes("Max processed bytes exceeded")) {
        return (
            <div className="flex flex-col ">
                <span>Exploration limit exceeded (max 1TB).</span>
                <span>To reduce data size:</span>
                <ul className="list-disc m-0 pl-4">
                    <li>Narrow the time range</li>
                    <li>Filter event names</li>
                    <li>Limit user sample by dimensions like country, install date, etc</li>
                </ul>
            </div>
        );
    }
    return msg;
};

const styleListMessage = (errorLength: number) => {
    if (errorLength > 1) {
        return {
            paddingLeft: "32px",
        };
    }

    return {
        listStyle: "none",
        paddingLeft: "16px",
    };
};

export const renderListErrorMessage = (message: string[]) => {
    return (
        <ul style={styleListMessage(message.length)}>
            {message.map((msg: string, index) => (
                <li key={index}>{renderSpecialMessage(msg)}</li>
            ))}
        </ul>
    );
};
export const QueryStatus: React.FC<{
    isNetworkError?: boolean;
    isUserChangeFirstTime: boolean;
    isLoading: boolean;
    isQueryComplete: boolean;
    dryRun?: DryRunInfo;
}> = ({ isUserChangeFirstTime, isLoading, isQueryComplete, dryRun, isNetworkError }) => {
    if (!isUserChangeFirstTime) return <div />;

    if (dryRun?.loading)
        return (
            <div className="flex items-center text-blue-500">
                <WaveDotsLoader color="blue" />
                Query Validating
            </div>
        );

    if (dryRun?.statusCode && dryRun?.message)
        return (
            <div>
                <Tooltip title={<div>{renderListErrorMessage(dryRun?.message ?? [])}</div>}>
                    <ExclamationCircleOutlined className="ml-2 text-red-500" />
                </Tooltip>
                <span className="text-red-500 ml-2">Validation failed</span>
            </div>
        );
    if (!dryRun) return <div />;

    return (
        <div className="flex ">
            {isNetworkError ? (
                <div className="flex items-center text-red-500">
                    <ExclamationCircleOutlined className="mr-2" />
                    Network timeout, please try again.
                </div>
            ) : (
                <>
                    {isLoading ? (
                        <div>
                            <div className="flex items-center">
                                <WaveDotsLoader color="black" />
                                <span>
                                    This query is processing with{" "}
                                    <b>{formatBytes(dryRun?.meta?.total_bytes_processed ?? 0)}</b>
                                </span>
                                {/* <span className="mr-2 text-blue-500">Executing query.</span> */}
                            </div>
                            {/* <span>
                                This query is processing with{" "}
                                <b>{formatBytes(dryRun?.meta?.total_bytes_processed ?? 0)}</b>
                            </span> */}
                        </div>
                    ) : isQueryComplete ? (
                        <div className="flex items-center">
                            <CheckCircleOutlined className="text-green-500 mr-2" />
                            <span className="mr-2">
                                Query completed. This query processed with{" "}
                                <b>{formatBytes(dryRun?.meta?.total_bytes_processed ?? 0)}</b>
                            </span>
                        </div>
                    ) : (
                        <span>
                            This query will process <b>{formatBytes(dryRun?.meta?.total_bytes_processed ?? 0)}</b> when
                            run.
                        </span>
                    )}
                </>
            )}
        </div>
    );
};
